import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateUser, logout } from "../Utils/Redux/UserSlice";
import cogoToast from 'cogo-toast-react-17-fix';
import { abortAllRequests } from '../Utils/AbortController';
import { AuthConsole, resetDocument } from '../Utils/helper';
import { runGuardedRefresh } from './refreshTokenGuard';

const useRefreshToken = (refreshTokenEndpoint) => {
  const dispatch = useDispatch()
  const User = useSelector(state => state.User)
  const { access_token, user_email, expiry_time, refresh_token } = User
  const [accessToken, setaccessToken] = useState(access_token)

  // Keep the latest refresh token in a ref so scheduled refreshes always use
  // the most recently rotated token, not the one captured at mount.
  const refreshTokenRef = useRef(refresh_token)
  refreshTokenRef.current = refresh_token

  const currentdate = new Date().toISOString()

  const sessionExpireLogout = async () => {
    cogoToast.info("Session Expired! Please log in again");
    abortAllRequests();
    await new Promise(resolve => setTimeout(resolve, 2000));
    resetDocument();
    window.location.reload();
    dispatch(logout());
  }

  const doRefresh = async () => {
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ refresh_token: refreshTokenRef.current })
    };
    try {
      const response = await fetch(refreshTokenEndpoint, requestOptions);
      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }
      const data = await response.json();
      if (data.data == null) {
        AuthConsole("No Data, logging out")
        throw new Error(`Request failed with status ${response.status}`);
      }
      if (data.status == "200") {
        setaccessToken(data.data.access_token)
        dispatch(updateUser({
          access_token: data.data.access_token,
          refresh_token: data.data.refresh_token,
          expiry_time: data.data.expiry_time
        }));
        return true;
      }
    }
    catch (error) {
      AuthConsole(error)
      if (error.message === 'Failed to fetch') {
        AuthConsole("Network error, Reloading")
      }
      else {
        sessionExpireLogout();
      }
    }
    return false;
  };

  const refreshAccessToken = () => runGuardedRefresh(doRefresh);

  useEffect(() => {
    let timeoutId;
    const refreshDelay = 3000; // Adjust the debounce delay as needed

    const handleTokenRefresh = () => {
      if (currentdate > expiry_time) {
        AuthConsole("Logging Out Here");

        sessionExpireLogout();
      } else {
        refreshAccessToken();
      }
    };

    const debouncedRefresh = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(handleTokenRefresh, refreshDelay);
    };

    debouncedRefresh();

    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  return accessToken;
};

export default useRefreshToken;
